export default __webpack_public_path__ + "static/media/facebook.0c3be1a1.svg";